export const useInitStore = defineStore('InitStore', () => {
  const loading = ref<boolean>(false)

  return { loading }
})
